"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLocation = void 0;
var createCleanQueryString_1 = require("./../utilities/create/createCleanQueryString");
var createLocation = function (_a) {
    var _b = _a.pathname, pathname = _b === void 0 ? '' : _b, query = _a.query, _c = _a.queryString, queryString = _c === void 0 ? '' : _c, queryNames = _a.queryNames;
    var mappedQuery = {};
    if (query) {
        for (var _i = 0, _d = Object.entries(queryNames); _i < _d.length; _i++) {
            var _e = _d[_i], key = _e[0], queryName = _e[1];
            mappedQuery[queryName] = query[key];
        }
    }
    var cleanQueryString = (0, createCleanQueryString_1.createCleanQueryString)({ query: mappedQuery });
    return {
        pathname: pathname,
        search: "".concat(queryString).concat(queryString && cleanQueryString ? '&' : '').concat(cleanQueryString),
        state: '',
        hash: '',
        key: '',
    };
};
exports.createLocation = createLocation;
